import { AccessLevel } from '../../../../../features/entities/pages-entities';
import { GetTranslationFunc } from '../../../../../features/providers/translations-provider';
import { ButtonVariant } from '../../../../common/button/types';

export const getButtonCta = (
  t: GetTranslationFunc,
  _clientProgramStatus?: unknown,
  accessLevel?: AccessLevel,
  alreadyProgram?: boolean,
) => {
  switch (accessLevel) {
    case 'free':
      if (alreadyProgram) {
        return {
          buttonCta: t('grant_single|resumeApplication'),
          variant: 'main-action' as ButtonVariant,
        };
      }
      return {
        buttonCta: t('grants|startApplicationCta'),
        variant: undefined,
      };

    case 'custom':
      if (!alreadyProgram) {
        return {
          buttonCta: t('grants|sendApplicationToHelloDarwin'),
          variant: undefined,
        };
      }
      return {
        buttonCta: t('grant_single|accessApplication'),
        variant: 'main-action' as ButtonVariant,
      };

    case 'premium':
      if (alreadyProgram) {
        return {
          buttonCta: t('grant_single|resumeApplication'),
          variant: 'main-action' as ButtonVariant,
        };
      }
      return {
        buttonCta: t('grants|startApplicationCta'),
        variant: undefined,
      };

    case 'expert':
      return {
        buttonCta: t('grantsFundingExplorer|grantsgrantCardLearnMore'),
        variant: 'navigation' as ButtonVariant,
      };

    default:
      return {
        buttonCta: t('grant_single|applyNow'),
        variant: undefined,
      };
  }
};
